
<div class="module module-tradeshow seminar" data-view="tradeshow">

    <div class="module module-tradeshow-results table-condensed">
        <div class="results">

            <div [class]="expand ? 'module-accordion seminar initial-active active' : 'module-accordion seminar initial-active'" data-view="accordion-item">
                <div (click)="updateAccordion()" class="title">
                    Events
                </div>
                <div id="events-accordion-content" class="content" style="max-height: none; transition: max-height 0.25s linear, padding 0.25s linear, border-color 0.25s linear;">

                    <div class="accordion-table-headline">
                        <div class="column-default column-1">
                            <span class="table-headline-label">Title</span>
                        </div>
                        <!--
                        <div class="column-default column-2">
                            <span class="table-headline-label">Description</span>
                        </div>
                        -->
                        <div class="column-default column-3">
                            <span class="table-headline-label">Date (yyyy-mm-dd)</span>
                        </div>
                        <div class="column-default column-4">
                            <span class="table-headline-label">Country</span>
                        </div>
                        <div class="column-default column-5">
                            <span class="table-headline-label">City</span>
                        </div>
                    </div>

                    <div *ngFor="let item of events" class="accordion-table-list">
                        <div class="column-1">
                            <a href="{{ item.url }}" target="_blank" class="download-tracked accordion-table-list-item-title-link">
                                {{ item.name }}
                            </a>
                        </div>

                        <!--
                        <div class="column-2">
                            <div class="accordion-table-list-item-info">
                                {{ item.description }}
                            </div>
                        </div>
                        -->

                        <div class="column-3">
                            <div class="accordion-table-list-item-info" *ngIf="item.start_date && item.end_date && item.start_date.split('T')[0] !== item.end_date.split('T')[0]">
                                {{ item.start_date.split('T')[0] }} to {{ item.end_date.split('T')[0] }}
                            </div>
                            <div class="accordion-table-list-item-info" *ngIf="item.start_date && item.end_date && item.start_date.split('T')[0] === item.end_date.split('T')[0]">
                                {{ item.start_date.split('T')[0] }}
                            </div>
                        </div>

                        <div class="column-4">
                            <div class="accordion-table-list-item-info">
                                {{ item.location.address.country }}
                            </div>
                        </div>

                        <div class="column-5">
                            <div class="accordion-table-list-item-info">
                                {{ item.location.address.locality }}
                            </div>
                        </div>
                    </div>

                    
                    <div *ngIf="events?.length === 0" class="accordion-table-list">
                        <div class="no-content-info-content">
                            <h3 class="no-content-info-headline">
                                <svg width="16" height="16" fill="currentColor" class="bi bi-exclamation-square-fill" viewBox="0 0 16 16">
                                    <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                </svg>
                                There are no items
                            </h3>
                            <p ngClass="no-content-info-body">
                                It seems like there are no items for selected criteria
                            </p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
